<script lang="ts" setup>
import { ref, inject, onMounted, watch } from 'vue';

import type { Ref } from 'vue';
import type { IManifest } from '@/types/IManifest';

const manifest = inject('manifest') as Ref<IManifest>;
const blobPath = ref<string>();

const generateBlob = () => {
  const blob = new Blob([JSON.stringify(manifest.value, null, 2)], { type: 'application/json' });

  blobPath.value = URL.createObjectURL(blob);
};

const manifestWatcher = () => {
  generateBlob();
};

const mountHandler = () => {
  generateBlob();
};

onMounted(mountHandler);
watch(manifest, manifestWatcher);
</script>

<template>
  <a
    :href="blobPath"
    :download="`manifest-${manifest.name || 'tour'}.v${manifest.version}.json`"
    class="cursor-pointer text-xs bg-blue-400 text-white p-1 text-center w-full my-0.5 last-of-type:mb-0 rounded-sm"
  >
    Export Manifest
  </a>
</template>
